const pad = (value) => String(value).padStart(2, '0');

const getLocalDateString = (date) => {
  const year = date.getUTCFullYear();
  const month = pad(date.getUTCMonth() + 1);
  const day = pad(date.getUTCDate());
  return `${year}-${month}-${day}`;
};

const getPakistanReferenceDate = (referenceDate = new Date()) => {
  const date = new Date(referenceDate);
  const utcMillis = Date.UTC(
    date.getUTCFullYear(),
    date.getUTCMonth(),
    date.getUTCDate(),
    date.getUTCHours(),
    date.getUTCMinutes(),
    date.getUTCSeconds(),
    date.getUTCMilliseconds()
  );
  const pakistanOffset = 5 * 60 * 60 * 1000;
  return new Date(utcMillis + pakistanOffset);
};

export const getSessionStart = (referenceDate = new Date(), shiftHour = 15) => {
  const date = new Date(referenceDate);
  const sessionDate = new Date(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds());
  if (sessionDate.getHours() < shiftHour) {
    sessionDate.setDate(sessionDate.getDate() - 1);
  }
  return new Date(sessionDate.getFullYear(), sessionDate.getMonth(), sessionDate.getDate(), shiftHour, 0, 0, 0);
};

export const getSessionEnd = (referenceDate = new Date(), shiftHour = 15) => {
  const start = getSessionStart(referenceDate, shiftHour);
  return new Date(start.getTime() + 24 * 60 * 60 * 1000);
};

export const getSessionDate = (referenceDate = new Date(), shiftHour = 15) => {
  const start = getSessionStart(referenceDate, shiftHour);
  const pktStart = getPakistanReferenceDate(start);
  return getLocalDateString(pktStart);
};

export const isWithinSession = (timestamp, referenceDate = new Date(), shiftHour = 15) => {
  if (!timestamp) return false;
  const actual = new Date(timestamp);
  const sessionStart = getSessionStart(referenceDate, shiftHour);
  const sessionEnd = getSessionEnd(referenceDate, shiftHour);
  return actual >= sessionStart && actual < sessionEnd;
};
